import React from 'react';
export const PhoneFrame = ({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) => <div className={`relative mx-auto w-[250px] sm:w-[280px] md:w-[300px] ${className}`} data-id="element-187" data-mp="1sw4igj5daijy">
    {/* Side buttons */}
    <span aria-hidden="true" className="absolute -left-[3px] top-[16%] h-[5%] w-[3px] rounded-l-sm bg-[#3a3531]" data-id="element-188" data-mp="1xsl7rgoaz2ym" />
    <span aria-hidden="true" className="absolute -left-[3px] top-[24%] h-[9%] w-[3px] rounded-l-sm bg-[#3a3531]" data-id="element-189" data-mp="22m7d0ns504ke" />
    <span aria-hidden="true" className="absolute -left-[3px] top-[35%] h-[9%] w-[3px] rounded-l-sm bg-[#3a3531]" data-id="element-190" data-mp="27mbqs61nul6x" />
    <span aria-hidden="true" className="absolute -right-[3px] top-[27%] h-[13%] w-[3px] rounded-r-sm bg-[#3a3531]" data-id="element-191" data-mp="2gkx6zujnto4j" />
    <span aria-hidden="true" className="absolute -right-[3px] top-[52%] h-[8%] w-[3px] rounded-r-sm bg-[#3a3531]" data-id="element-192" data-mp="2lka212koq1i7" />

    {/* Titanium shell */}
    <div className="relative aspect-[9/19.5] rounded-[3.1rem] bg-[#2b2724] p-[9px] shadow-[0_40px_80px_-30px_rgba(46,40,32,0.75),0_0_0_1px_rgba(176,141,63,0.35),inset_0_0_0_1.5px_rgba(255,255,255,0.12)]" data-id="element-193" data-mp="m8h4n4tziu4y">
      {/* Screen */}
      <div className="relative h-full w-full overflow-hidden rounded-[2.55rem] bg-black" data-id="element-194" data-mp="3461hls3v13ch">
        {children}

        {/* Dynamic Island */}
        <span aria-hidden="true" className="pointer-events-none absolute left-1/2 top-[10px] z-10 h-[26px] w-[32%] -translate-x-1/2 rounded-full bg-black" data-id="element-195" data-mp="2z7zxd3up6xzf" />

        {/* Home indicator */}
        <span aria-hidden="true" className="pointer-events-none absolute bottom-[7px] left-1/2 z-10 h-[4px] w-[36%] -translate-x-1/2 rounded-full bg-black/60" data-id="element-196" data-mp="3rvvug9o6irwq" />
      </div>
    </div>
  </div>;